module.exports = require("@jswork/react-github-corner");